import { type FunctionComponent } from 'react';
import * as icons from './components';
import type { IconWrapperProps } from './types';

const getIcon: FunctionComponent<IconWrapperProps> = (props) => {
  const { children } = props;
  const name = children?.toString();

  if (typeof name !== 'string') {
    console.error('Icon name must be a string.');

    return 'error';
  }

  const IconComponent = icons[name as keyof typeof icons];

  if (!IconComponent) {
    console.error(`Invalid icon name: ${name}`);

    return 'error';
  }

  return <IconComponent {...props} />;
};

export const Icon: FunctionComponent<IconWrapperProps> = (props) => <>{getIcon(props)}</>;
